import React from "react";
import { useLocation } from "react-router-dom";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const setSessionHideLinks = (isHideLinks) => {
  if (isHideLinks) {
    sessionStorage.setItem(HIDE_LINKS, isHideLinks);
  } else {
    sessionStorage.removeItem(HIDE_LINKS);
  }
};

const useHideLinks = () => {
  let query = useQuery();
  const hideLink = query.get(HIDE_LINKS);
  const isHideLinks = "true" === hideLink;
  setSessionHideLinks(isHideLinks);
};

export const HIDE_LINKS = "hideLinks";
export const isHidingLinks = () =>
  "true" === sessionStorage.getItem(HIDE_LINKS);

export default useHideLinks;
